import type { PropsWithChildren } from 'react';
import { Link } from '@flos/react-ui';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';

const ContactUsLink = ({ children }: PropsWithChildren): React.JSX.Element => {
    const [showCallMeModal, setShowCallMeModal] = useState(false);

    return (
        <>
            <Link
                onClick={() => {
                    setShowCallMeModal(true);
                }}
                className="u-color-primary-2-base"
            >
                {children}
            </Link>

            {showCallMeModal &&
                createPortal(
                    <CallMeModal
                        showModal={showCallMeModal}
                        closeModal={() => {
                            setShowCallMeModal(false);
                        }}
                        activityCode="dss_effective_date_conflict"
                        isDefault={false}
                    />,
                    document.body
                )}
        </>
    );
};

export default ContactUsLink;
